import * as React from 'react';
import { SVGProps } from 'react';

const IconUnlockSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 6.5a2.5 2.5 0 0 1 5 0V9H7a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V10a1 1 0 0 0-1-1H11V6.5a4.5 4.5 0 0 0-9 0V7h2v-.5Zm10.633 8.898a2 2 0 1 0-1.266 0L12 19.5h4l-1.367-4.102Z"
    />
  </svg>
);
export default IconUnlockSizeM;
